import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import PublicIcon from '@mui/icons-material/Public';

import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import SidebarBox from 'components/SidebarBox';
import ContractDownloadBox from 'components/ContractDownloadBox';
import EntitySidebar from 'components/EntitySidebar';

import { PUBLIC_URL } from 'const';
import { OrderSidebar_order$key } from '__generated__/OrderSidebar_order.graphql';

type Props = {
  order: OrderSidebar_order$key;
};

const OrderSidebar: FC<Props> = props => {
  const order = useFragment(
    graphql`
      fragment OrderSidebar_order on Order {
        orderNr
        url
        cancellationRequestedAt

        pack {
          id
        }

        ...ContractDownloadBox_order
        ...EntitySidebar_entity
      }
    `,
    props.order
  );

  const { orderNr, url, pack, cancellationRequestedAt } = order;

  return (
    <EntitySidebar entity={order}>
      {orderNr && <SidebarBox label="Užsakymo numeris:">{orderNr}</SidebarBox>}

      <Divider />

      {cancellationRequestedAt && (
        <>
          <SidebarBox label="Gauta atšaukimo užklausa:">
            {cancellationRequestedAt}
          </SidebarBox>

          <Divider />
        </>
      )}

      <ContractDownloadBox order={order} />

      {pack && url && (
        <>
          <SidebarBox icon={PublicIcon}>
            <Link href={`${PUBLIC_URL}${url}`} target="_blank" rel="noreferrer">
              Kelionės puslapis svetainėje
            </Link>
          </SidebarBox>

          <Divider />
        </>
      )}

      <SidebarBox icon={BeachAccessIcon}>
        {pack ? (
          <Link href={`/packages/${pack.id}`}>Kelionės administravimas</Link>
        ) : (
          'Kelionė ištrinta'
        )}
      </SidebarBox>
    </EntitySidebar>
  );
};

export default OrderSidebar;
